module.exports = __webpack_public_path__ + "media/images/mobile/logo_v-03a30f279a47f8ef89cc1decb09a4461.gif";